// frontend/src/modules/expenses/components/AmountInput.tsx
import * as React from 'react';
import { Input } from '../../../components/ui/input';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../../../components/ui/select';

const COMMON_CURRENCIES = ['USD', 'EUR', 'GBP', 'CAD', 'AUD', 'JPY', 'INR', 'CHF', 'CNY', 'BRL', 'MXN', 'SGD', 'ZAR'];

interface AmountInputProps {
  amount: number | '';
  currency: string;
  onAmountChange: (value: number | '') => void;
  onCurrencyChange: (currency: string) => void;
  /** Append extra currencies (e.g. tenant default) to the picker. */
  extraCurrencies?: string[];
  disabled?: boolean;
  required?: boolean;
}

export function AmountInput({
  amount,
  currency,
  onAmountChange,
  onCurrencyChange,
  extraCurrencies,
  disabled,
  required,
}: AmountInputProps) {
  const currencies = React.useMemo(() => {
    const set = new Set<string>([...COMMON_CURRENCIES, ...(extraCurrencies ?? []), currency].filter(Boolean));
    return Array.from(set);
  }, [extraCurrencies, currency]);

  return (
    <div className="grid grid-cols-[1fr_120px] gap-2">
      <Input
        type="number"
        min={0}
        step="0.01"
        inputMode="decimal"
        value={amount === '' ? '' : amount}
        onChange={(e) => {
          const raw = e.target.value;
          if (raw === '') { onAmountChange(''); return; }
          const n = Number(raw);
          onAmountChange(Number.isFinite(n) ? n : '');
        }}
        placeholder="0.00"
        disabled={disabled}
        required={required}
        className="font-mono tabular-nums text-right"
      />
      <Select value={currency} onValueChange={onCurrencyChange} disabled={disabled}>
        <SelectTrigger><SelectValue /></SelectTrigger>
        <SelectContent>
          {currencies.map((c) => (
            <SelectItem key={c} value={c}>{c}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
